import { booleanAttribute } from "#ce/utils/props";
const ITEMS_PER_ROW_OPTIONS = Object.freeze(["auto", "1", "2", "3", "4", "5", "6"]);

export const props = Object.freeze({
  /**
   * Fixed number of columns per row on desktop. Set to "auto" for a responsive auto-fill grid.
   *
   * @type {Number|String}
   * @default "auto"
   * @values auto, 1, 2, 3, 4, 5, 6
   * @storybook-control radio
   */
  itemsPerRow: {
    type: [Number, String],
    default: "auto",
    validator: (value) => ITEMS_PER_ROW_OPTIONS.includes(String(value)),
  },
  /**
   * Fixed number of columns per row on medium screens. Leave undefined to inherit `itemsPerRow`.
   *
   * @type {Number|String}
   * @default undefined
   * @values auto, 1, 2, 3, 4, 5, 6
   * @storybook-control radio
   */
  itemsPerRowMd: {
    type: [Number, String],
    default: undefined,
    validator: (value) => value === undefined || ITEMS_PER_ROW_OPTIONS.includes(String(value)),
  },
  /**
   * Switch to horizontal scrolling with scroll-snap on small screens. Overridden by `connectOnSm` when both are set.
   *
   * @type {Boolean|String}
   * @default false
   */
  scrollOnSm: booleanAttribute(),
  /**
   * Collapse tiles into a single connected container on small screens with shared dividers. Connected mode forces a row layout on small screens, strips individual `card` styling (shadows, borders) in favour of the shared container's surface, and takes precedence over `scrollOnSm`.
   *
   * @type {Boolean|String}
   * @default false
   */
  connectOnSm: booleanAttribute(),
  /**
   * Equalise tile heights to the tallest child. Ignored when `connectOnSm` is active.
   *
   * @type {Boolean|String}
   * @default false
   */
  equalizeHeights: booleanAttribute(),
  /**
   * Small-screen override for equalised heights. Leave undefined to inherit `equalizeHeights`.
   *
   * @type {Boolean|String}
   * @default undefined
   * @storybook-table-subcategory Small Screen
   */
  equalizeHeightsSm: booleanAttribute(undefined),
});
